import { createAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../store/configureStore';
import { throwOnError } from './utils';

export type Maintenance = {
  current_timestamp: string;
  maintenance_schedule: {
    start_at: string;
    end_at: string;
    description: string;
  };
};

export const GET_MAINTENANCE_SCHEDULE = createAction<Maintenance>('GET_MAINTENANCE_SCHEDULE');

export const getMaintenanceSchedule =
  (baseURL: string): AppThunk =>
  (dispatch) =>
    fetch(`${baseURL}/v1/schedule`)
      .then(throwOnError<Maintenance>)
      .then((maintenanceSchedule) => {
        dispatch(GET_MAINTENANCE_SCHEDULE(maintenanceSchedule));
      });
